module.exports = __webpack_public_path__ + "img/outline.13f3e5c8.jpg";